import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";

const GastoEstimadoPF = ({ data }) => {
  return (
    <>
      <TitleStripe>Gasto Estimado</TitleStripe>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="flex items-center gap-2">
          <div className="font-semibold">
            Valor Gasto com cartão de crédito:
          </div>
          <div>{data?.AmountSpentCreditCard}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">% gasto com cartão de crédito:</div>
          <div>{data?.PercentageSpentOnCreditCard}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Gasto médio total:</div>
          <div>{data?.SpentIncome}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Compromentimento total:</div>
          <div>{data?.IncomeCommitmentValuePercentage}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Gasto com parcelas:</div>
          <div>{data?.SpentInInstallments}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">% gasto com parcelas:</div>
          <div>{data?.PercentageSpentOnInstallments}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Imóvel Financiado:</div>
          <div>{data?.RealEstateFinancing}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Carro Financiado:</div>
          <div>{data?.VehicleFinancing}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Consórcio:</div>
          <div>{data?.Consortia}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="font-semibold">Data de referência:</div>
          <div>
            {data?.DateReference?.Day}/{data?.DateReference?.Month}/
            {data?.DateReference?.Year}
          </div>
        </div>
      </div>
    </>
  );
};

export default GastoEstimadoPF;
